import { useEffect, useState } from "react";
import IconDelete from "../../../../layout/others/icon-x.svg";
import { DropDownMultiCheck } from "../DropDownMultiCheck";
import { TagService } from "../../../../services/TagService";

export default function Tags({ searchObject, setSearchObject, t }) {
  const [tagsList, setTagsList] = useState([]);

  useEffect(() => {
    TagService.getTagsList().then((data) => {
      setTagsList(data);
    });
  }, []);

  function setTags(list) {
    setSearchObject({ ...searchObject, tags: list });
  }

  function clearTags() {
    let _searchObject = { ...searchObject };
    _searchObject.tags = [];

    setSearchObject(_searchObject);
  }

  return (
    <div>
      <legend className="fontsize-legend">{t("Tags")}</legend>
      {searchObject.tags?.length !== 0 && (
        <button
          onClick={clearTags}
          className="btn-clear-language-level position-clear-button"
        >
          <img src={IconDelete} alt="ico-ppl" height="12px" width="auto" />
        </button>
      )}
      <DropDownMultiCheck
        dataList={tagsList.map((x) => {
          return { id: x.id, description: x.name };
        })}
        selecteds={searchObject.tags}
        setSelecteds={setTags}
      />
    </div>
  );
}
